import { Component } from '@angular/core';
import { AppConfig } from './app.config';

@Component({
	selector: 'app-root',
	template: `<router-outlet></router-outlet>`
})
export class AppComponent {
	constructor() {
		document.title = `${AppConfig.company} - Portale Distribuzione`;
	}
}

/**
 * @since 17.3.0
 * @description rimosse funzionalità di SEO e analytics inutilizzate
 */
// export class AppComponent implements OnInit {

// 	ngOnInit() {
// 		this.analytics.trackPageViews();
// 		this.seoService.trackCanonicalChanges();
// 	}
// }
